import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaGruposConta: [],
  grupoContaPesquisa: {
    nome: undefined,
    pagina: 0
  },
  labelQuantidade: '',
  grupoContaSelecionado: {
    id: 0,
    nome: ''
  },
  listaTipoDespesa: [],

  gruposDisponiveis: [],
}

const mutations = {
  atualizarListaGruposConta(state, payload) {
    if(state.grupoContaPesquisa.pagina === 0) {
      state.listaGruposConta = payload.lista;
    } else {
      state.listaGruposConta.push(...payload.lista);
    }

    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " grupo conta encontrado" : " grupos de conta encontrados");
  },
  limparGruposContaListadas(state) {
    state.listaGruposConta = [];
  },
  limparGrupoContaPesquisa(state) {
    state.grupoContaPesquisa = {
      nome: undefined,
      pagina: 0
    };

    if(state.grupoContaPesquisa.tipoDespesa) {
      state.grupoContaPesquisa.tipoDespesa = undefined
    }
    if(state.grupoContaPesquisa.tipo) {
      state.grupoContaPesquisa.tipo = undefined
    }
  },
  atualizarGrupoContaSelecionado(state, payload) {
    state.grupoContaSelecionado = payload;
    state.listaTipoDespesa = [payload.grupoPai]
  },
  novoGrupoConta(state) {
    state.grupoContaSelecionado = {
      id: 0,
      nome: ''
    }
  },
  atualizarListaTipoDespesa(state, payload) {
    state.listaTipoDespesa = payload;
  },

  atualizarGruposDisponiveis(state, payload) {
    state.gruposDisponiveis = payload
  }
}

const actions = {
  listarGruposConta(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaGruposConta', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('listarGruposConta', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparGruposContaListadas(context) {
    context.commit('limparGruposContaListadas');
  },
  limparGrupoContaPesquisa(context){
    context.commit('limparGrupoContaPesquisa');
  },
  recuperarGrupoConta(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarGrupoContaSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarGrupoConta', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  novoGrupoConta(context) {
    context.commit('novoGrupoConta');
  },
  gravarGrupoConta(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarGrupoContaSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarGrupoConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  removerGrupoConta(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novoGrupoConta');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('removerGrupoConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },

  gravarTipoDespesa(context, payload) {
    return axios.post(URLS.TIPO_CONTA_GRAVAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch('gravarTipoDespesa', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarTipoDespesa(context, payload) {
    return axios.post(URLS.TIPO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaTipoDespesa', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("listarTipoDespesa", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerTipoDespesa(context, payload) {
    return axios.post(URLS.TIPO_CONTA_REMOVER, payload)
    .then(response => {
      switch (response.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("removerTipoDespesa", payload)
            }
          }).catch(error => {
            throw error
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarGruposContaSelect(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarGruposDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('listarGruposContaContaSelect', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
}

export default {
  state,
  mutations,
  actions
}